
export const clamp = (ideal: number, min: number, max: number) => {
    return Math.min(Math.max(ideal, min), max);
}

export default clamp;
